// Orbe, remove unused country options, set Germany as International market.

// The script is a little complicated...
// The main idea is to show the country options (in the same order) from the admin panel metaobjects and
// To display the "International" option which will lead to the international store. This option is not
// implemented by Orbe, so I have to improvise.

// Germany is selected as the "international" option.
// I can't duplicate nodes as original Orbe code doesn't support new node refs, so I made a workaround...
// I use Nouvelle-Calédonie / New Caledonia (XPF) option which probably won't be ever used as the "replacement" option,
// I override it's content with custom "International" label, flag and german data attributes for some internal Orbe logic.

// After all modifications, I reorder the options, so they match the order from the admin panel
// This one is also a little tricky... for some reason, on the first page load, options aren't available (not loaded),
// so I have to observe the options list mutations to reorder options only after the load.
// But on the second load (a simple page reload), there are no mutations observed and the normal script which fires
// on "DOMContentLoaded" event works as expected.

// And on the very end, after all modifications, I look for the "International" option
// (or the first available if the international option isn't provided) on the list and click it to prevent cases
// in which user's country (which isn't on the list) will be preselected.

const GERMAN_COUNTRY_CODE = 'DE';
const INTERNATIONAL_COUNTRY_CODE = 'ZZ';
const INTERNATIONAL_REPLACEMENT_OPTION_COUNTRY_CODE = 'NC';
const INTERNATIONAL_REPLACEMENT_OPTION_ID = 'md-form__select__country__NC';
const GERMAN_OPTION_ID = 'md-form__select__country__DE';

const SEPARATE_MARKETS_COUNTRY_CODES_LIST = window.redirectBannerOptions.map((option) => option.countryOptionCode);
const INTERNATIONAL_OPTION = window.redirectBannerOptions.find(
  (option) => option.countryOptionCode === INTERNATIONAL_COUNTRY_CODE
);
const COUNTRY_OPTION_LABEL_SELECTOR = '.md-form__select__span';
const COUNTRY_OPTION_IMG_SELECTOR = '.md-form__select__img';
const ORBE_POPUP_FORM_ID = 'md-modal__form__id';

document.addEventListener('DOMContentLoaded', (event) => {
  const orbePopupForm = document.querySelector(`#${ORBE_POPUP_FORM_ID}`);

  if (!orbito || !SEPARATE_MARKETS_COUNTRY_CODES_LIST.length || !orbePopupForm) return;

  const countryPicker = orbito?.elements?.formUlCountrySelect;
  const countryOptions = countryPicker?.children ? Array.from(countryPicker?.children) : [];

  // Replace country option with international option.
  const replacementOption = document.querySelector(`#${INTERNATIONAL_REPLACEMENT_OPTION_ID}`);
  const replacementOptionLink = replacementOption.querySelector('a');

  const germanyOption = document.querySelector(`#${GERMAN_OPTION_ID}`);
  const germanyOptionLink = germanyOption.querySelector('a');

  replacementOption.querySelector(COUNTRY_OPTION_LABEL_SELECTOR).innerText = INTERNATIONAL_OPTION.countryOptionName;

  replacementOption
    .querySelector(COUNTRY_OPTION_IMG_SELECTOR)
    .style.setProperty('background-image', `url('${INTERNATIONAL_OPTION.countryOptionFlag}')`, 'important');

  countryOptions.forEach((countryOptionLink) => {
    countryOptionLink.addEventListener('click', () => {
      const orbePopupForm = document.querySelector(`#${ORBE_POPUP_FORM_ID}`);
      const selected = orbePopupForm.querySelector(COUNTRY_OPTION_IMG_SELECTOR);
      if (countryOptionLink.dataset.country == GERMAN_COUNTRY_CODE) {
        selected.style.setProperty('background-image', `url('${INTERNATIONAL_OPTION.countryOptionFlag}')`, 'important');
      } else {
        selected.style.removeProperty(
          'background-image',
          `url('${INTERNATIONAL_OPTION.countryOptionFlag}')`,
          'important'
        );
      }
    });
  });

  replacementOption.dataset.name = germanyOption.dataset.name;
  replacementOption.dataset.customCountryCode = INTERNATIONAL_COUNTRY_CODE;
  replacementOption.dataset.country = germanyOption.dataset.country;

  replacementOptionLink.dataset.primarymarket = germanyOptionLink.dataset.primarymarket;
  replacementOptionLink.dataset.currency = germanyOptionLink.dataset.currency;
  replacementOptionLink.dataset.symbol = germanyOptionLink.dataset.symbol;
  replacementOptionLink.dataset.primary = germanyOptionLink.dataset.primary;
  replacementOptionLink.dataset.defaultlocale = germanyOptionLink.dataset.defaultlocale;
  replacementOptionLink.dataset.subfoldersuffix = germanyOptionLink.dataset.subfoldersuffix;
  replacementOptionLink.dataset.domainurl = germanyOptionLink.dataset.domainurl;
  replacementOptionLink.dataset.country = germanyOptionLink.dataset.country;
  replacementOptionLink.dataset.value = germanyOptionLink.dataset.value;
  replacementOptionLink.dataset.locales = germanyOptionLink.dataset.locales;
  replacementOptionLink.dataset.namelocales = germanyOptionLink.dataset.namelocales;

  // If Germany is not on the list, we don't need it anymore.
  if (!SEPARATE_MARKETS_COUNTRY_CODES_LIST.includes(GERMAN_COUNTRY_CODE)) {
    countryPicker.removeChild(germanyOption);
  }

  // Filter country options, except international replacement and german in case we need to switch them.
  countryOptions.forEach((countryOption) => {
    if (
      !SEPARATE_MARKETS_COUNTRY_CODES_LIST.includes(countryOption.dataset.country) &&
      countryOption.dataset.country !== INTERNATIONAL_REPLACEMENT_OPTION_COUNTRY_CODE &&
      countryOption.dataset.country !== GERMAN_COUNTRY_CODE
    ) {
      countryPicker.removeChild(countryOption);
    }

    const countryRelatedConfig = window.redirectBannerOptions.find(
      (bannerConfig) => bannerConfig.countryOptionCode === countryOption.dataset.country
    );

    // Set overrides if needed
    if (countryRelatedConfig) {
      countryOption.querySelector(COUNTRY_OPTION_LABEL_SELECTOR).innerText = countryRelatedConfig.countryOptionName;

      if (countryRelatedConfig.countryOptionFlag) {
        countryOption.querySelector(COUNTRY_OPTION_IMG_SELECTOR).src = countryRelatedConfig.countryOptionFlag;
      }
    }
  });

  // Sort the children to match the options order from the admin panel on page reload.
  reorderCountryOptions({ countryPicker, replacementOption });

  const config = { childList: true, subtree: true };

  const callback = (mutationList, observer) => {
    // if fired, child list changed, it means, we can reorder it now.
    const anyChildListMutation = mutationList.find((mutation) => mutation.type === 'childList');

    if (anyChildListMutation) {
      // Sort the children to match the options order from the admin panel on the first website load.
      reorderCountryOptions({ countryPicker, replacementOption });

      observer.disconnect();
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(orbito?.elements?.formUlCountrySelect, config);
});

function reorderCountryOptions({ countryPicker, replacementOption }) {
  const filteredCountryOptions = countryPicker?.children ? Array.from(countryPicker?.children) : [];

  const countryOptionsToSort = Array.from(filteredCountryOptions);
  const countryOptionsToSortObject = countryOptionsToSort.reduce((allCountryOptions, countryOption) => {
    // International option override.
    if (countryOption.dataset.customCountryCode === INTERNATIONAL_COUNTRY_CODE) {
      allCountryOptions[INTERNATIONAL_COUNTRY_CODE] = replacementOption;
    } else {
      allCountryOptions[countryOption.dataset.country] = countryOption;
    }

    return allCountryOptions;
  }, {});

  SEPARATE_MARKETS_COUNTRY_CODES_LIST.forEach((countryCode) =>
    orbito?.elements?.formUlCountrySelect?.appendChild(countryOptionsToSortObject[countryCode])
  );

  // Click international or first available if user country doesn't exist on list to prevent unexpected behaviour.
  let defaultCountryOption;
  const internationalOption = filteredCountryOptions?.find(
    (countryOption) => countryOption.id === INTERNATIONAL_REPLACEMENT_OPTION_ID
  );
  const firstAvailableOption = filteredCountryOptions?.[0];

  orbito?.getRemoteCountryCode().then((value) => {
    const userCountryOption = filteredCountryOptions?.find((countryOption) => countryOption.dataset.country === value);

    if (userCountryOption) {
      defaultCountryOption = userCountryOption;
    } else if (internationalOption) {
      defaultCountryOption = internationalOption;
    } else {
      defaultCountryOption = firstAvailableOption;
    }

    const countryOptionLink = defaultCountryOption.querySelector('a');

    if (countryOptionLink) {
      countryOptionLink.click();
    }
  });
}
